if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"framework_shell","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return /^(259|275|5|522|792|850|96)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}